import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => {
  if (state && state.authState) {
    return state.authState;
  } else {
    return initialState;
  }
};

export const selectUserData = createSelector(
  [selectDomain],
  (state) => state.userData
);
export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading
);
export const SelectIsLogin = createSelector(
  [selectDomain],
  (state) => state.isLogin
);
export const SelectToken = createSelector(
  [selectDomain],
  (state) => state.token
);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectForgotPasswordForm = createSelector(
  [selectDomain],
  (state) => state.forgotPasswordForm
);
export const selectRegisterForm = createSelector(
  [selectDomain],
  (state) => state.registerForm
);

export const selectIsToken = createSelector(
  [selectDomain],
  (state) => state.isToken
);
export const selectTogglePassword = createSelector(
  [selectDomain],
  (state) => state.togglePassword
);
export const selectToggleConfirmPassword = createSelector(
  [selectDomain],
  (state) => state.toggleConfirmPassword
);

